export const SectionHeader = ({ kicker, title, children, testId }) => (
  <div className="mb-10 flex flex-col justify-between gap-4 md:flex-row md:items-end" data-testid={testId}>
    <div>
      <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-cyan-400">{kicker}</p>
      <h2 className="mt-2 font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">{title}</h2>
    </div>
    {children}
  </div>
);
